import axios, { AxiosResponse } from 'axios'

import gql from '@js/api/utils/gql'
import { env } from '@js/utils/env'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { CustomerRegistration } from '@js/api/types/customer/CustomerRegistration'

interface DeleteCustomerRegistrationPayload {
  registrationId: number
}

interface DeleteCustomerRegistrationResponse {
  data: {
    wceiDeleteRegistration: CustomerRegistration
  }
  errors?: [{ message: string }]
}

export const deleteCustomerRegistrationMutation = gql`
  mutation wceiDeleteRegistration($registrationId: Int!) {
    wceiDeleteRegistration(input: { 
      registration_id: $registrationId
    }) {
      registration_id
        registration_number
        personal {
            address
            address_two
            city
            state
            country
            postcode
            phone
            secondary_phone
        }
        professional {
            licenses {
                license_id
                license_number
                license_type
                license_state
            }
            primary_employment
            employer_name
            employer_city
            employer_state
            hear_about
            certifications
        }
        item {
          sku
          course_option
        }    
    }
  }
 `

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const deleteCustomerRegistration = async (payload: DeleteCustomerRegistrationPayload): Promise<CustomerRegistration> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<DeleteCustomerRegistrationResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: deleteCustomerRegistrationMutation,
      variables: payload,
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  return data.data.wceiDeleteRegistration
}
